import { render, staticRenderFns } from "./ActiveSharesReviews.vue?vue&type=template&id=2db6e32c&"
import script from "./ActiveSharesReviews.vue?vue&type=script&lang=js&"
export * from "./ActiveSharesReviews.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSharesReviews.vue?vue&type=style&index=0&id=2db6e32c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports